// Libs
import React, { useState, Fragment } from "react";

// Icons
import fireIcon from "../images/fire-icon.svg";

// Style
import "./BestSelling.css";

function BestSelling({ t }) {
  const [hover, setHover] = useState(false);

  return (
    <Fragment>
      <div className="">
        <div
          className={`
            BestSelling__container
            ${hover ? "BestSelling__container-expanded" : ""}
          `}
        >
          <div>{t("BestSelling.Tooltip.Top")}</div>
          <div>{t("BestSelling.Tooltip.Bottom")}</div>
        </div>

        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className="BestSelling__icon"
        >
          <img src={fireIcon} alt="Best Seller" />
        </div>
      </div>
    </Fragment>
  );
}

export default BestSelling;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/BestSelling.js